import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { SquareX } from 'lucide-react';

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn, SearchInput } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const 경로옵션 = [
    "대시보드", "거래내역", "정산달력", "가맹점 정산내역", "에이전트 정산내역",
    "상세정보", "가맹점", "통합에이전트", "수기결제", "수기결제취소",
    "수기결제승인내역", "수기결제처리내역", "할부관리", "블랙리스트카드", "관리자 조회", "수수료안내"
];

function Admin() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(20);
    const [loading, setLoading] = useState(true);

    // 1) 처음에는 등록 폼을 보이기 위해 createModal을 true로, updateModal을 false로 설정
    const [createModal, setCreateModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);

    const [message, setMessage] = useState("");
    const [adminData, setAdminData] = useState([]);
    const [combineData, setCombineData] = useState([]);
    const [clickData, setClickData] = useState(null);

    // MyData: 임시
    const MyData = { role: "SUPER" };

    const [reload, setReload] = useState(false);

    // 날짜 관련
    const inputRef = useRef(null);
    const pickerRef = useRef(null);

    const [preDate, setPreDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [nextDate, setNextDate] = useState(dayjs().format("YYYY-MM-DD"));

    // -------------------------------
    // 초기 세팅
    // -------------------------------
    useEffect(() => {
        dispatch(change_Current_Location("관리자 조회"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "관리자 메뉴",
                subTitle: "관리자 조회",
            })
        );
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch]);

    // reload 토글 시 새로운 목록 불러오기
    useEffect(() => {
        setPage(1);
        AdminData();
    }, [reload]);

    // -------------------------------
    // 관리자 목록 조회 API
    // -------------------------------
    const AdminData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/admin", {
                withCredentials: true,
                params: {},
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setAdminData(tmp?.data?.admin ?? []);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    // -------------------------------
    // Litepicker
    // -------------------------------
    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false,
            format: "YYYY-MM-DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                picker.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY-MM-DD"));
                    setNextDate(end.format("YYYY-MM-DD"));
                });
            },
        });
        return () => {
            pickerRef.current?.destroy();
        };
    }, []);

    // 페이지 로드시, 초기 날짜 범위 설정
    useEffect(() => {
        setDateRange(dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD"));
    }, []);

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch();
    };

    const onSubmitSearch = () => {
        setReload((e) => !e);
    };

    // -------------------------------
    // 테이블 헤더
    // -------------------------------
    const tableHeaderData = [
        // { no: 1, text: "NO", width: "50px", textAlign: "center" },
        { no: 3, text: "관리자", width: "100px", textAlign: "center" },
        { no: 4, text: "이메일", width: "130px", textAlign: "center" },
        { no: 7, text: "아이디", width: "80px", textAlign: "center" },
        { no: 8, text: "PG코드", width: "200px", textAlign: "center" },
        { no: 9, text: "등급", width: "70px", textAlign: "center" },
        // { no: 6, text: "등록일자", width: "150px", textAlign: "center" },
        { no: 5, text: "삭제여부", width: "60px", textAlign: "center" },
    ];

    // -------------------------------
    // 테이블 데이터 가공
    // -------------------------------
    useEffect(() => {
        let tableBodyData = [];
        if (adminData.length) {
            adminData.forEach((data, i) => {
                let rowArr = [
                    // { no: 1, text: i + 1, width: "50px", textAlign: "center" },
                    { no: 3, text: data.name, width: "100px", textAlign: "left" },
                    { no: 4, text: data.email, width: "130px", textAlign: "left" },
                    { no: 7, text: data.admin_id, width: "80px", textAlign: "left" },
                    { no: 8, text: data.co_id, width: "200px", textAlign: "center" },
                    { no: 9, text: data.role, width: "70px", textAlign: "center" },
                    // { no: 6, text: data.reg_date, width: "150px", textAlign: "center" },
                    {
                        no: 5,
                        text: (
                            <div className="flex justify-center items-center">
                                <a
                                    className="delete flex items-center text-danger pointer"
                                    onClick={(evt) => {
                                        evt.stopPropagation();
                                        onDeleteData(data.id);
                                    }}
                                >
                                    <SquareX width={15} height={15} /> 삭제
                                </a>
                            </div>
                        ),
                        width: "60px",
                        textAlign: "center",
                    },
                ];

                rowArr.id = data.id;
                rowArr.raw = data;

                tableBodyData.push(rowArr);
            });
        }
        setCombineData(tableBodyData);
    }, [adminData]);

    // 한 페이지당 보여줄 개수만큼 slice
    const filter_tableBodyData = combineData.slice(
        (page - 1) * maxFirstPage,
        page * maxFirstPage
    );

    // -------------------------------
    // 삭제
    // -------------------------------
    const onDeleteData = async (adminId) => {
        if (window.confirm("관리자 데이터를 삭제하시겠습니까?")) {
            try {
                const response = await axios.post(
                    process.env.REACT_APP_API + "/api/admin/delete",
                    { adminId },
                    { withCredentials: true }
                );
                let tmp = response?.data;
                if (tmp?.code < 2000) {
                    AdminData();
                } else {
                    setMessage({ msg: "관리자 삭제에 실패했습니다." });
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    // -------------------------------
    // 테이블 행 클릭 => 수정 폼 열기
    // -------------------------------
    const handleRowClick = (rowArr) => {
        setClickData(rowArr.raw);
        setCreateModal(false);  // 등록 폼 닫기
        setUpdateModal(true);   // 수정 폼 열기
    };

    // -------------------------------
    // 페이지당 개수 변경
    // -------------------------------
    const handleChange = (event) => {
        setMaxFirstPage(Number(event.target.value));
    };

    return (
        <div className="content" id="contents">
            {loading && <LoadingModal />}
            <MessageModal message={message} />

            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                    <div className="button_wrap separate" style={{ marginTop: "0px" }}>
                        {/* <SearchCrteateBtn
                            type={"관리자 등록"}
                            onClick={() => {
                                setUpdateModal(false);
                                setCreateModal(true);
                                setClickData({});
                            }}
                        /> */}
                    </div>
                </form>
            </div>

            <div
                className="intro-y box intro-padding"
            >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row" }}>
                    <CountAmountLeft tableBodyData={combineData} />
                    <div className="excel-disable">
                        <CountSelect onChange={handleChange} maxFirstPage={maxFirstPage} />
                    </div>
                </div>

                {/* 좌우 레이아웃 */}
                <div className="div-flex-2">
                    {/* 좌측: 목록 테이블 */}
                    <div style={{ maxWidth: "650px", width: "100%" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={combineData}
                            filter_tableBodyData={filter_tableBodyData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            onRowClick={handleRowClick}
                            clickData={clickData} // 행 클릭 시 색상처리를 위해 넘겨줌
                        />
                    </div>

                    {/* 우측: 등록/수정 폼 */}
                    <div
                        style={{
                            maxWidth: "450px",
                            marginTop: "12px",
                            width: "100%",
                        }}
                    >
                        {
                            !clickData&& !createModal && adminData?.length > 0 && (
                                <div className='div-flex-1-2' style={{ border: "16px solid #575757", width: "450px", height: "710px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", fontWeight: "bold", color: "gray", textAlign: "center" }}>
                                    왼쪽 목록에서 관리자를 선택하면<br />
                                    세부정보를 확인할 수 있습니다.
                                </div>
                            )
                        }
                        {/* (1) 관리자 등록 폼 */}
                        {MyData?.role === "SUPER" && createModal && (
                            <div
                                style={{
                                    backgroundColor: "#575757",
                                    padding: "16px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                        padding: "0 10px",
                                        borderBottom: "1px solid #E5E5E5",
                                        backgroundColor: "#fff",
                                    }}
                                >
                                    <button
                                        className="tab-btn active"
                                        style={{
                                            padding: "12px 10px 8px",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            color: "#222",
                                            background: "transparent",
                                            border: "none",
                                            borderBottom: "3px solid #3182F6",
                                            transition: "all 0.2s ease-in-out",
                                            cursor: "pointer",
                                        }}
                                    >
                                        관리자 등록
                                    </button>
                                </div>
                                <div style={{ padding: "0 10px", backgroundColor: "#fff" }}>
                                    <CreateInfo
                                        setModal={setCreateModal}
                                        setMessage={setMessage}
                                        setReload={setReload}
                                    />
                                </div>
                            </div>
                        )}

                        {/* (2) 관리자 수정 폼 */}
                        {updateModal && clickData && (
                            <div
                                style={{
                                    backgroundColor: clickData?.id ? "rgb(69 69 69)" : "",
                                    padding: "16px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        padding: "0 10px",
                                        borderBottom: "1px solid #E5E5E5",
                                        backgroundColor: "#fff",
                                    }}
                                >
                                    <button
                                        className="tab-btn active"
                                        style={{
                                            padding: "12px 10px 8px",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            color: "#222",
                                            background: "transparent",
                                            border: "none",
                                            borderBottom: "3px solid #3182F6",
                                            transition: "all 0.2s ease-in-out",
                                            cursor: "pointer",
                                        }}
                                    >
                                        관리자 수정
                                    </button>
                                    {MyData?.role === "SUPER" && (
                                        <div
                                            className="button_wrap separate"
                                            style={{ marginTop: "0px" }}
                                        >
                                            <SearchCrteateBtn
                                                type={"신규등록"}
                                                onClick={() => {
                                                    // 신규등록 버튼 -> 수정 폼은 닫고 등록 폼은 열기
                                                    setUpdateModal(false);
                                                    setCreateModal(true);
                                                    setClickData(null);
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div style={{ padding: "0 10px", backgroundColor: "#fff" }}>
                                    <UpdateInfo
                                        setModal={setUpdateModal}
                                        setMessage={setMessage}
                                        clickData={clickData}
                                        setReload={setReload}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

function CreateInfo({ setModal, setMessage, setReload }) {
    // 1) 초기 formData에 '경로옵션'을 배열로 추가
    const initialFormData = {
        관리자명: "",
        이메일: "",
        아이디: "",
        패스워드: "",
        PG코드: "",
        등급: "SUPER",
        경로옵션: [] // 체크박스로 선택한 경로들을 저장할 배열
    };

    // 2) formData state
    const [formData, setFormData] = useState(initialFormData);

    // 중복 제출 방지
    const [isSubmitting, setIsSubmitting] = useState(false);

    // (A) 체크박스 + 일반 input 처리
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        // 체크박스(배열) 처리
        if (type === "checkbox") {
            setFormData((prev) => {
                const 기존 = prev[name] || []; // name="경로옵션"
                return {
                    ...prev,
                    [name]: checked
                        ? [...기존, value]
                        : 기존.filter((item) => item !== value),
                };
            });
        } else {
            // 일반 text/select
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    // (B) 등록 처리
    const onSubmit = async () => {
        if (isSubmitting) return;

        if (
            !formData.관리자명.trim() ||
            !formData.이메일.trim() ||
            !formData.아이디.trim() ||
            !formData.패스워드.trim()
        ) {
            setMessage({ msg: "입력하지 않은 항목이 있습니다." });
            return;
        }

        setIsSubmitting(true);
        try {
            // API 전송 시, 체크박스 배열도 함께 전송
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/admin/regist",
                {
                    name: formData.관리자명,
                    email: formData.이메일,
                    password: formData.패스워드,
                    adminId: formData.아이디,
                    role: formData.등급,
                    co_id: formData.PG코드,
                    pagePaths: formData.경로옵션, // 서버에서 pagePaths 같은 필드로 받는다고 가정
                },
                { withCredentials: true }
            );

            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: "관리자 등록에 성공했습니다." });
                setReload((prev) => !prev);
                setModal(false);
            } else {
                setMessage({ msg: "관리자 등록에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "관리자 등록 중 오류가 발생했습니다." });
        } finally {
            setIsSubmitting(false);
        }
    };

    // (C) 취소 => formData 초기화
    const handleCancel = () => {
        setFormData(initialFormData);
    };

    // 체크박스 레이아웃 계산용 (필요하다면)
    const [checkboxHeight, setCheckboxHeight] = useState(60);
    const refCheckboxHeight = useRef(null);

    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog">
                <div className="marginTop30 admin-modal-sty">
                    <div
                        style={{
                            padding: "0 0 0.5rem",
                            height: "625px",
                            overflowY: "auto",
                            fontSize: "12px",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {/* 폼 영역 */}
                        <div className="list-info-box">
                            <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                <ul>
                                    {/* 관리자명 */}
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                관리자명
                                            </span>
                                            <input
                                                id="관리자명"
                                                name="관리자명"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.관리자명}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>

                                    {/* 이메일 */}
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                이메일
                                            </span>
                                            <input
                                                id="이메일"
                                                name="이메일"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.이메일}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>

                                    {/* 아이디 */}
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                아이디
                                            </span>
                                            <input
                                                id="아이디"
                                                name="아이디"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.아이디}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>

                                    {/* 패스워드 */}
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                패스워드
                                            </span>
                                            <input
                                                id="패스워드"
                                                name="패스워드"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.패스워드}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>

                                    {/* PG코드 */}
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                PG코드
                                            </span>
                                            <input
                                                id="PG코드"
                                                name="PG코드"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.PG코드}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>

                                    {/* 등급 */}
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                등급
                                            </span>
                                            <select
                                                id="등급"
                                                name="등급"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.등급}
                                                onChange={handleChange}
                                            >
                                                <option value="SUPER">SUPER</option>
                                                <option value="ADMIN">ADMIN</option>
                                                <option value="MANAGER">MANAGER</option>
                                            </select>
                                        </div>
                                    </li>

                                    {/* 경로옵션 (체크박스) */}
                                    {/* <li>
                                        <div className="inner" style={{ width: "100%", height: "100%" }}>
                                            <div
                                                className="left-text"
                                                style={{ width: "90px", height: `${checkboxHeight}px` }}
                                            >
                                                페이지권한
                                            </div>
                                            <div
                                                className="flex flex-wrap gap-1"
                                                style={{ fontSize: "0.7rem", padding: "5px" }}
                                                ref={refCheckboxHeight}
                                            >
                                                {경로옵션.map((path) => (
                                                    <label
                                                        key={path}
                                                        className="flex items-center gap-1 cursor-pointer"
                                                        style={{ width: "120px" }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            name="경로옵션"   // 중요! handleChange에서 name="경로옵션"으로 받아야 함
                                                            value={path}
                                                            checked={formData.경로옵션.includes(path)}
                                                            onChange={handleChange}
                                                            style={{
                                                                width: "14px",
                                                                height: "14px",
                                                                border: "1px solid #646464",
                                                            }}
                                                        />
                                                        {path}
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    </li> */}
                                </ul>
                            </div>
                        </div>

                        {/* 버튼 영역 */}
                        <div className="modal-footer" style={{ marginTop: "auto" }}>
                            <button
                                type="button"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={onSubmit}
                                disabled={isSubmitting}
                            >
                                등록
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary w-20 close_btn"
                                onClick={handleCancel}
                                style={{
                                    backgroundColor: "darkred",
                                    marginLeft: "10px",
                                    border: "none",
                                }}
                            >
                                취소
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function UpdateInfo({ setModal, setMessage, clickData, setReload }) {
    // -------------------------------
    // 1) 최초(초기) 값 설정
    // -------------------------------
    const initialFormData = {
        관리자명: clickData.name ?? "",
        이메일: clickData.email ?? "",
        아이디: clickData.admin_id ?? "",
        패스워드: "", // 필요 시 빈 문자열 또는 기존 값 사용
        PG코드: clickData.co_id ?? "",
        등급: clickData.role ?? "SUPER",
        경로옵션: clickData.pagePaths ?? [],  // 서버에서 받은 경로 리스트가 있다면
    };

    // -------------------------------
    // 2) 단일 formData state
    // -------------------------------
    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        setFormData(initialFormData)
    }, [clickData])

    // -------------------------------
    // 중복 클릭 방지용
    // -------------------------------
    const [isSubmitting, setIsSubmitting] = useState(false);

    // (A) 체크박스 + 일반 input 처리
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setFormData((prev) => {
                const 기존 = prev[name] || [];
                return {
                    ...prev,
                    [name]: checked
                        ? [...기존, value]
                        : 기존.filter((item) => item !== value),
                };
            });
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    // (B) 취소 => formData 초기값으로 복원
    const handleCancel = () => {
        setFormData(initialFormData);
    };

    // (C) 수정 처리
    const onSubmit = async () => {
        if (isSubmitting) return;

        if (!formData.관리자명.trim() || !formData.이메일.trim() || !formData.패스워드.trim()) {
            setMessage({ msg: "수정할 정보를 정확히 입력해주세요." });
            return;
        }

        if (window.confirm("관리자 정보를 수정하시겠습니까?")) {
            setIsSubmitting(true);
            try {
                const response = await axios.post(
                    process.env.REACT_APP_API + "/api/admin/update",
                    {
                        adminId: clickData.id, // 또는 formData.아이디 (DB PK가 어떤 것인지에 따라 조정)
                        password: formData.패스워드,
                        email: formData.이메일,
                        name: formData.관리자명,
                        role: formData.등급,
                        co_id: formData.PG코드,
                        pagePaths: formData.경로옵션, // 체크박스 선택한 배열 전송
                    },
                    { withCredentials: true }
                );
                const tmp = response?.data;
                if (tmp?.code < 2000) {
                    setMessage({ msg: "관리자 수정에 성공했습니다." });
                    setReload((prev) => !prev);
                    setModal(false);
                } else {
                    setMessage({ msg: "관리자 수정에 실패했습니다." });
                }
            } catch (error) {
                console.error(error);
                setMessage({ msg: "관리자 수정 중 오류가 발생했습니다." });
            } finally {
                setIsSubmitting(false);
            }
        }
    };

    // 체크박스 높이 등 필요하다면
    const [checkboxHeight, setCheckboxHeight] = useState(60);
    const refCheckboxHeight = useRef(null);

    // -------------------------------
    // UI 구조 (CreateModal과 유사)
    // -------------------------------
    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog">
                <div className="marginTop30 admin-modal-sty">
                    <div
                        style={{
                            padding: "0 0 0.5rem",
                            height: "625px",
                            overflowY: "auto",
                            fontSize: "12px",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <div className="list-info-box">
                            <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                <ul>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                관리자명
                                            </span>
                                            <input
                                                id="관리자명"
                                                name="관리자명"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.관리자명}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>

                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                이메일
                                            </span>
                                            <input
                                                id="이메일"
                                                name="이메일"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.이메일}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>

                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                아이디
                                            </span>
                                            <input
                                                id="아이디"
                                                name="아이디"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.아이디}
                                                onChange={handleChange}
                                                disabled // 아이디 수정 불가
                                            />
                                        </div>
                                    </li>

                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                패스워드
                                            </span>
                                            <input
                                                id="패스워드"
                                                name="패스워드"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.패스워드}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>

                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                PG코드
                                            </span>
                                            <input
                                                id="PG코드"
                                                name="PG코드"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.PG코드}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>

                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span
                                                className="left-text"
                                                style={{ width: "90px", height: "34px" }}
                                            >
                                                등급
                                            </span>
                                            <select
                                                id="등급"
                                                name="등급"
                                                className="right-text"
                                                style={{ width: "calc(100% - 92px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.등급}
                                                onChange={handleChange}
                                            >
                                                <option value="SUPER">SUPER</option>
                                                <option value="ADMIN">ADMIN</option>
                                                <option value="MANAGER">MANAGER</option>
                                            </select>
                                        </div>
                                    </li>

                                    {/* 경로옵션 (체크박스) */}
                                    {/* <li>
                                        <div className="inner" style={{ width: "100%", height: "100%" }}>
                                            <div
                                                className="left-text"
                                                style={{ width: "90px", height: `${checkboxHeight}px` }}
                                            >
                                                페이지권한
                                            </div>
                                            <div
                                                className="flex flex-wrap gap-1"
                                                style={{ fontSize: "0.7rem", padding: "5px" }}
                                                ref={refCheckboxHeight}
                                            >
                                                {경로옵션.map((path) => (
                                                    <label
                                                        key={path}
                                                        className="flex items-center gap-1 cursor-pointer"
                                                        style={{ width: "120px" }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            name="경로옵션"  // 중요!
                                                            value={path}
                                                            checked={formData.경로옵션.includes(path)}
                                                            onChange={handleChange}
                                                            style={{
                                                                width: "14px",
                                                                height: "14px",
                                                                border: "1px solid #646464",
                                                            }}
                                                        />
                                                        {path}
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    </li> */}
                                </ul>
                            </div>
                        </div>

                        {/* 버튼 영역 */}
                        <div className="modal-footer" style={{ marginTop: "auto" }}>
                            <button
                                type="button"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={onSubmit}
                                disabled={isSubmitting}
                            >
                                수정
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary w-20 close_btn"
                                onClick={handleCancel}
                                style={{
                                    backgroundColor: "darkred",
                                    marginLeft: "10px",
                                    border: "none",
                                }}
                            >
                                취소
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Admin